import {
  ExternalLinkType,
  FunctionDto,
  ProjectSizeCategoryDto,
  SearchResultDto,
  IndustryDto,
  SpecialityDto,
  UserDto,
  BusinessLineDto,
  ProcessDtoUsedInLibraries,
  SearchType,
  DocumentContentType
} from '../services/generated';
import {ProcessUsedInLibraries} from './ProcessUsedInLibraries';

export class SearchResult implements SearchResultDto {
  public id: number
  public title: string | null;
  public type: SearchType;
  public unitId: number | null;
  public unitTitle: string | null;
  public unit: string | undefined;
  public url: string | null;
  public auditable: boolean;
  public documentOwner: string | null;
  public content: string | null;
  public library: string | null;
  public external: boolean;
  public function: FunctionDto | null;
  public language: string | null;
  public isFavorite: boolean;
  public processes: ProcessDtoUsedInLibraries[] | null;
  public get languageCode() {
    return this.language;
  }
  public operatingUnit: string | null;
  public contentType: DocumentContentType | null;
  public processOwner: UserDto | null;
  public secondaryProcessOwners: UserDto[] | null;
  public projectSizeCategories: ProjectSizeCategoryDto[] | null;
  public relativeUrl: string | null;
  public revision: string | null;
  public relevantToId: number | null;
  public relevantTo: string | null;
  public securityLevel: string | null;
  public industries: IndustryDto[] | null;
  public specialities: SpecialityDto[] | null;
  public documentId: string | null;
  public documentKind: string | null;
  public approved: string | null;
  public nextConfirmationDate: string | null;
  public externalLinkType: ExternalLinkType;
  public isExternal: boolean | null;
  public documentInReview: boolean;
  public documentIsOutdated: boolean;
  public businessLines: BusinessLineDto[] | null;
  public typicalId: string | null;
  public nativeTool: string | null;
  public responsibility: string | null;
  public cabinetType: string | null;
  public height: string | null;
  public width: string | null;
  public depth: string | null;
  public plinth: string | null;
  public cableEntry: string | null;
  public cabinetAccess: string | null;
  public cabinetSwingFrame: string | null;
  public equipmentOnDoor: string | null;
  public controlSystem: string | null;
  public system: string | null
  public numberOfControllers: string | null;
  public cpuRedundancy: string | null;
  public powerInput: string | null;
  public powerSupplyRedundancy: string | null;
  public ioRedundancy: string | null;
  public isIOSignals: string | null;
  public ioSignalsCount: string | null;
  public forExAreasType: string | null;
  public ip: string | null;
  public projectName: string | null;
  public accessToSourcesTitle: string | null;
  public accessToSourcesUrl: string | null;
  public comment: string | null;
  public industry: string | null;
  public manufacturedBy: string | null;
  public approver: string | null;
  public preparedBy: string | null;
  public designeRespPerson: string | null;
  public docStatus: string | null;
  public previewUrl: string | null;
  public created: string | null;
  public keyWords: string[] | null;
  public cabinetTypicalDocuments: string[] | null;
  public get preparedUrl() {
    return !(this.type === SearchType.Process)
      ? this.url || ''
      : `/unit/${this.unitId}/process/${this.id}`;
  }


  public get typeString() {
    switch (this.type) {
      case SearchType.Process:
        return 'Process';
      case SearchType.Document:
        return 'Document';
      case SearchType.ExternalLink:
        return 'External Link';
      case SearchType.PDC:
        return 'PDC';
      case SearchType.CabinetTypical:
        return 'Cabinet Typical';
    }
    return '';
  }

  public get externalLinkTypeString() {
    switch (this.externalLinkType) {
      case ExternalLinkType.IMSProcess:
        return 'IMS Process';
      case ExternalLinkType.Site:
        return 'Site';
      case ExternalLinkType.SoftwareApplication:
        return 'Software Application';
      case ExternalLinkType.Examples:
        return 'Examples';
      case ExternalLinkType.ELearning:
        return 'e-Learning';
      default:
        return '';
    }
  }

  public functionString: string = '';

  constructor(searchResult: SearchResultDto, unit?: string) {
    this.title = searchResult.title;
    this.type = searchResult.type;
    this.id = searchResult.id;
    this.unitId = searchResult.unitId;
    this.unitTitle = searchResult.unitTitle;
    this.unit = unit;
    this.url = searchResult.url;
    this.auditable = searchResult.auditable;
    this.documentOwner = searchResult.documentOwner;
    this.content = searchResult.content;
    this.library = searchResult.library;
    this.external = searchResult.external;
    this.function = searchResult.function;
    this.language = searchResult.language;
    this.contentType = searchResult.contentType;
    this.operatingUnit = searchResult.operatingUnit;
    this.processOwner = searchResult.processOwner;
    this.secondaryProcessOwners = searchResult.secondaryProcessOwners;
    this.projectSizeCategories = searchResult.projectSizeCategories;
    this.relativeUrl = searchResult.relativeUrl;
    this.securityLevel = searchResult.securityLevel;
    this.industries = searchResult.industries;
    this.specialities = searchResult.specialities;
    this.documentId = searchResult.documentId;
    this.documentKind = searchResult.documentKind;
    this.revision = searchResult.revision;
    this.relevantToId = searchResult.relevantToId;
    this.relevantTo = searchResult.relevantTo;
    this.approved = searchResult.approved;
    this.nextConfirmationDate = searchResult.nextConfirmationDate;
    this.externalLinkType = searchResult.externalLinkType;
    this.isExternal = searchResult.external;
    this.documentInReview = searchResult.documentInReview;
    this.documentIsOutdated = searchResult.documentIsOutdated;
    this.businessLines = searchResult.businessLines;
    this.keyWords = searchResult.keyWords;
    this.typicalId = searchResult.typicalId;
    this.nativeTool = searchResult.nativeTool;
    this.responsibility = searchResult.responsibility;
    this.cabinetType = searchResult.cabinetType;
    this.height = searchResult.height;
    this.width = searchResult.width;
    this.depth = searchResult.depth;
    this.plinth = searchResult.plinth;
    this.cableEntry = searchResult.cableEntry;
    this.cabinetAccess = searchResult.cabinetAccess;
    this.cabinetSwingFrame = searchResult.cabinetSwingFrame;
    this.equipmentOnDoor = searchResult.equipmentOnDoor;
    this.controlSystem = searchResult.controlSystem;
    this.system = searchResult.system;
    this.numberOfControllers = searchResult.numberOfControllers;
    this.cpuRedundancy = searchResult.cpuRedundancy;
    this.powerInput = searchResult.powerInput;
    this.powerSupplyRedundancy = searchResult.powerSupplyRedundancy;
    this.ioRedundancy = searchResult.ioRedundancy;
    this.isIOSignals = searchResult.isIOSignals;
    this.ioSignalsCount = searchResult.ioSignalsCount;
    this.forExAreasType = searchResult.forExAreasType;
    this.ip = searchResult.ip;
    this.projectName = searchResult.projectName;
    this.accessToSourcesTitle = searchResult.accessToSourcesTitle;
    this.accessToSourcesUrl = searchResult.accessToSourcesUrl;
    this.comment = searchResult.comment;
    this.industry = searchResult.industry;
    this.manufacturedBy = searchResult.manufacturedBy;
    this.approver = searchResult.approver;
    this.preparedBy = searchResult.preparedBy;
    this.designeRespPerson = searchResult.designeRespPerson;
    this.created = searchResult.created;
    this.docStatus = searchResult.docStatus;
    this.isFavorite = searchResult.isFavorite;
    this.previewUrl = searchResult.previewUrl;
    this.cabinetTypicalDocuments = searchResult.cabinetTypicalDocuments;
    this.processes =
      searchResult.processes?.map(process => new ProcessUsedInLibraries(process)) || null;
    Object.defineProperty(this, 'functionString', {
      get() {
        return searchResult.function?.value || '';
      }
    });

  }
}
